import React from 'react';
import { useSelector } from 'react-redux';
import Spinner from './Spinner';

const GlobalLoadingIndicator = () => {
  const { login, logout, refreshToken, initializeAuth } = useSelector((state) => state.loading);

  const isLoading = login || logout || refreshToken || initializeAuth;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100] transition-opacity duration-300 ${
        isLoading ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}
      aria-hidden={!isLoading}
      role="dialog"
      aria-labelledby="loading-spinner"
    >
      {isLoading && <Spinner id="loading-spinner" aria-live="assertive" />}
    </div>
  );
};

export default GlobalLoadingIndicator;
